// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","466":"component---src-pages-docs-mdx-slug-js"}[chunkId] + "-" + {"125":"3ea2b98126acac5dd5f2","293":"cce1176b60ea3af1a8e1","466":"980cf8ad03e10645f980"}[chunkId] + ".js";
};